//
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import Service from '@/services/api/service'

//
export default class extends Service {
    
    //
    static model = WarehouseModel
}
